<div>
  <!-- <mat-icon>refresh</mat-icon> -->
  <!-- <i class="ti-reload fa fa-spin"></i> -->
  <div class="loader"></div>
  <p>{{ message }}</p>
</div>
